import React,{Component} from 'react'
import './index.scss'
const classNames = require('classnames')
class Loading extends Component {
	state = {
	 imgURL:this.props.imgURL||'',
     content:this.props.content||'正在加载中'
	}
	render() {
		const {imgURL,content} = this.state;
		const {isLoadingShow,area} = this.props;//area 表示是局部loading 
		return (
			<div className={classNames("loading",{'fn-hide':!isLoadingShow},{'home':area},{'default':!imgURL})}>
				<p className="content">{imgURL? <img className="loading-img" src={imgURL} alt = ''></img>: <i className="loading-icon"></i>}<span>{content}</span></p>
			</div>
		)
	}
}
export default Loading
